// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-4" role="contentinfo">
      <div className="container">
        <div className="row">
          {/* Navigation Links */}
          <div className="col-md-4 mb-3">
            <h5>Explore</h5>
            <ul className="list-unstyled">
              <li>
                <NavLink to="/" className="footer-link">Home</NavLink>
              </li>
              <li>
                <NavLink to="/html" className="footer-link">HTML</NavLink>
              </li>
              <li>
                <NavLink to="/css" className="footer-link">CSS</NavLink>
              </li>
              <li>
                <NavLink to="/javascript" className="footer-link">JavaScript</NavLink>
              </li>
              <li>
                <NavLink to="/bootstrap" className="footer-link">Bootstrap</NavLink>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="col-md-4 mb-3">
            <h5>Have feedback? Contact us</h5>
            <ul className="list-unstyled">
              <li>Email: <a href="mailto:admin@fortae.com.au" className="footer-link">support@thecodeeproject.com</a></li>
            </ul>
          </div>

          {/* About/Project Info */}
          <div className="col-md-4 mb-3">
            <h5>About The Code-E Project</h5>
            <p>
              A resource for students learning frontend web development, built with a sleek black-and-white design using Bootstrap.
            </p>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="row mt-3">
          <div className="col-12 text-center">
            <p className="mb-0">
              &copy; {currentYear} The Code-E Project. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;